import React, { createContext, useContext } from 'react';

import type { TSmeShareContext, TContext } from './models';

const Context = createContext<TContext>({
    geoGroups: ['sme'],
    deliveryTimeslotPeriod: 31,
    processKey: 'rko_questionnaire',
    timeslotsLimit: 5,
});

export const useShareContext = () => useContext(Context);

/** Контекст-обертка для возможности шаринга КА на все страницы sme */
export const SmeShareContext = ({
    children,
    deliveryTimeslotPeriod = 31,
    geoGroups = ['sme'],
    productInfo,
    requestInfo,
    callbackProductInfo,
    callbackRequestInfo,
    timeslotsLimit = 5,
    isUnitedSteps = false,
    processKey = 'rko_questionnaire',
}: TSmeShareContext) => (
    <Context.Provider
        value={{
            deliveryTimeslotPeriod,
            productInfo,
            requestInfo,
            geoGroups,
            timeslotsLimit,
            callbackProductInfo,
            callbackRequestInfo,
            processKey,
            isUnitedSteps,
        }}
    >
        {children}
    </Context.Provider>
);
